/**
 * (event.shiftKey + event.key) => (event.key)
 */
//   Använd _keys.html för att samla in tecken.
export const keyboardShiftMap = {
  "Q": "q",
  "W": "w",
  "E": "e",
  "R": "r",
  "T": "t",
  "Y": "y",
  "U": "u",
  "I": "i",
  "O": "o",
  "P": "p",
  "Å": "å",
  "Dead": "Dead",
  "Ä": "ä",
  "Ö": "ö",
  "L": "l",
  "K": "k",
  "S": "s",
  "A": "a",
  "D": "d",
  "F": "f",
  "G": "g",
  "H": "h",
  "J": "j",
  "*": "*",
  "Enter": "Enter",
  "_": "-",
  ":": ".",
  ";": ",",
  "M": "m",
  "N": "n",
  "B": "b",
  "V": "v",
  "C": "c",
  "X": "x",
  "Z": "z",
  "\"": "2",
  "!": "1",
  "#": "3",
  "¤": "4",
  "%": "5",
  "&": "6",
  "/": "/",
  "(": "8",
  ")": "9",
  "=": "0",
  "?": "+",
  "-": "-",
  "+": "+",
  "ArrowUp": "ArrowUp",
  "PageUp": "PageUp",
  "Home": "Home",
  "ArrowRight": "ArrowRight",
  "End": "End",
  "PageDown": "PageDown",
  "ArrowDown": "ArrowDown",
  "Insert": "Insert",
  "Delete": "Delete"
}